import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import {Stadium, Terrace} from "@/modules/stadium/entity";
import TerraceExpander from "@/modules/stadium/services/TerraceExpander";
import StadiumFoundationExpander from "@/modules/stadium/services/StadiumFoundationExpander";

@injectable()
export class ExpansionEventSubscriber implements EventSubscriber {
  constructor(
    @inject(TerraceExpander) private terraceExpander: TerraceExpander,
    @inject(StadiumFoundationExpander) private stadiumFoundationExpander: StadiumFoundationExpander,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: EvaluateDayEvent, callback: this.onEvaluateDayEvent},
    ];
  }

  async onEvaluateDayEvent(event: EvaluateDayEvent): Promise<void> {
    const terraces = await Terrace
      .createQueryBuilder('terrace')
      .where(
        'terrace.seatsFinishedAt IS NOT NULL AND terrace.seatsFinishedAt < :currentDate',
        {currentDate: event.season.currentDateRaw}
      )
      .getMany();

    await terraces
      .forEachAsync<Terrace>((terrace: Terrace) => this.terraceExpander.finish(terrace));

    const stadiums = await Stadium
      .createQueryBuilder('stadium')
      .innerJoinAndSelect('stadium.terraces', 'terrace')
      .where(
        'stadium.foundationFinishedAt IS NOT NULL AND stadium.foundationFinishedAt < :currentDate',
        {currentDate: event.season.currentDateRaw}
      )
      .getMany();

    await stadiums
      .forEachAsync<Stadium>((stadium: Stadium) => this.stadiumFoundationExpander.finish(stadium));
  }
}